import _ from 'lodash';
import axios from 'axios';
import { getI18n } from 'react-i18next';
import { showErrorNotification, showInfoNotification } from './notifications';
import Constants from '../utils/Constants';
import { createErrorMessage } from '../components/errors/Errors';
import { VALIDATION_CONFIRMATION_TOTP_INVALID, VALIDATION_NEW_2FA_UNEXPECTED } from '../components/errors/TwoFAErrors';

export const RESET_2FA_STORE_TOKEN = 'RESET_2FA_STORE_TOKEN';
export const RESET_2FA_TOKEN_INVALIDATED = 'RESET_2FA_TOKEN_INVALIDATED';
export const RESET_2FA_INITIATE_DOWNLOAD_QR_IMAGE = 'RESET_2FA_DOWNLOAD_QR_IMAGE';
export const RESET_2FA_QR_IMAGE_DOWNLOADED = 'RESET_2FA_QR_IMAGE_DOWNLOADED';
export const RESET_2FA_TOTP_TOKEN_VALIDITY_CHANGED = 'RESET_2FA_TOTP_TOKEN_VALIDITY_CHANGED';

const onSuccess = (dispatch) => {
    dispatch(showInfoNotification(getI18n().t('reset-2fa.notification.success-enabled')));
    dispatch(reset2FATokenInvalidated());
};

const onError = (dispatch) => (error) => {
    const { response } = error;
    if (response && response.data && _.isArray(response.data)) { // application validation error
        if (response.data.length === 1 && response.data[0].code === VALIDATION_CONFIRMATION_TOTP_INVALID) {
            dispatch(totpTokenValidityChanged(true));
            return;
        } else {
            response.data.forEach((errObject) => {
                const message = createErrorMessage(errObject.code, errObject.params);
                dispatch(showErrorNotification(message));
            });
        }
    } else { // unexpected error
        const errorMessageCode = VALIDATION_NEW_2FA_UNEXPECTED;
        const errorMessageParams = { message: error.message };
        const message = createErrorMessage(errorMessageCode, errorMessageParams);
        dispatch(showErrorNotification(message));
    }

    dispatch(reset2FATokenInvalidated());
};

export const storeReset2FAToken = (token) => ({
    type: RESET_2FA_STORE_TOKEN,
    payload: {
        token,
    },
});

export const reset2FATokenInvalidated = () => ({
    type: RESET_2FA_TOKEN_INVALIDATED,
});

export const initiateDownloadQRImage = () => ({
    type: RESET_2FA_INITIATE_DOWNLOAD_QR_IMAGE,
});

export const qrImageDownloaded = (qrImage) => ({
    type: RESET_2FA_QR_IMAGE_DOWNLOADED,
    payload: {
        qrImage,
    },
});

export const totpTokenValidityChanged = (invalid) => ({
    type: RESET_2FA_TOTP_TOKEN_VALIDITY_CHANGED,
    payload: {
        invalid,
    },
});

export const reset2FA = (jwtToken, totpToken) => (dispatch) => axios
    .post(Constants.RESET_2FA_TOKEN_PATH, { jwtToken, totpToken })
    .then(() => onSuccess(dispatch))
    .catch(onError(dispatch));

export const downloadQRImage = (token) => (dispatch) => axios
    .post(Constants.GENERATE_2FA_QRIMAGE_PATH, { token })
    .then((resp) => dispatch(qrImageDownloaded(resp.data)))
    .catch(onError(dispatch));
